
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
 



@Injectable()
export class DataShareService {

    shareDataMethod$: Observable<any>;
    private methodSubject = new BehaviorSubject<any>(false);
    constructor() {
        this.shareDataMethod$ = this.methodSubject.asObservable();
    }
    onError(data:any) {
        
        this.methodSubject.next(data.error);
    }
   

   

}
